import Account from '@/orm/models/Account/Account';

export default function useChangePeriod() {
  function changePeriod(periodId) {
    return Account.api().changePeriod(periodId);
  }

  return {
    changePeriod,
  };
}
